import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./frontened/Home";
import About from "./frontened/About";
import Courses from "./frontened/Courses";
import Contact from "./frontened/Contact";
import Services from "./frontened/Services";
import MockTest from "./frontened/MockTest";
import Product from "./frontened/Product";
import PrivacyPolicy from "./frontened/PrivacyPolicy";
import RefundCancellationPolicy from "./frontened/RefundCancellationPolicy";
import TermsOfUse from "./frontened/TermsOfUse";
import Disclaimer from "./frontened/Disclaimer";
import ScrollToTop from "./component/ScrollToTop";
import DashboardLayout from "./component/DashboardLayout";
import UserDashboard from "./component/UserDashboard";
import Profile from "./component/Profile";
import Progress from "./component/Progress";
import Schedule from "./component/Schedule";
import Feedback from "./component/Feedback";
import Notification from "./component/Notification";
import MockTestPage from "./frontened/MockTestPage";
import CourseMockTest from "./frontened/CourseMockTest";
//import Login from "./frontened/Login";
import EnrollmentPage from "./frontened/EnrollmentPage";

// 📦 Driving School Dashboard Pages
//import DrivingSchoolDashboard from "./frontened/DrivingSchoolDashboard";
import DSHome from "./component/dashboard/Dashboard";
import DSStudents from "./component/dashboard/OurStudents";
import DSVehicles from "./component/dashboard/SchoolVehicles";

import DSProfile from "./component/dashboard/ProfileDs";

// 📦 Vendor Dashboard Pages
//import VendorDashboard from "./frontened/VendorDashboard";
import VDashboard from "./component/vendordashboard/Dashboard";
import VProfile from "./component/vendordashboard/ProfileV";
import VMyServices from "./component/vendordashboard/MyServices";
import VendorStudent from "./component/vendordashboard/VendorStudent";
import VendorBookings from "./component/vendordashboard/VendorBookings";
import { AuthContext } from "./context/AuthContext";
import ServiceDetails from "./frontened/subpage/ServiceDetail";
import ProductDetails from "./frontened/subpage/ProductDetail";
// import CartPage from "./frontened/subpage/CartPage";
import CourseDetail from "./frontened/subpage/CourseDetail";
import DrivingSchoolLayout  from "./component/DrivingSchoolLayout";
import VendorLayout from "./component/VendorLayout";
import AgentLayout from "./component/AgentLayout";
import AgentDashboard from "./component/agentdashboard/AgentDashboard";
import AgentStudents from "./component/agentdashboard/AgentStudents";
import AgentCommissions from "./component/agentdashboard/AgentCommissions";
import AgentProfile from "./component/agentdashboard/AgentProfile";

const AppRouter = () => {
 const { user } = useContext(AuthContext); 

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* 🌐 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/course/:slug" element={<CourseDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/product" element={<Product />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-cancellation-policy" element={<RefundCancellationPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/mocktest" element={<MockTest />} />
        <Route path="/course-mock-test" element={<CourseMockTest />} />
        <Route path="/mock-test-page" element={<MockTestPage />} />
        <Route path="/services/:slug" element={<ServiceDetails />} />
        <Route path="/product-details/:slug" element={<ProductDetails />} />
        {/* <Route path="/cart" element={<CartPage />} /> */}

        {/* 🔐 Login Route */}
        {/* <Route path="/login" element={<Login />} /> */}

        {/* 📝 Registration Route */}
        <Route
          path="/register"
          element={
            <EnrollmentPage
              isFromProfile={false}
              closeTo="/"
              successTo="/dashboard"
            />
          }
        />

        {/* 🧾 Enrollment Route */}
        <Route
          path="/enroll"
          element={
            user ? (
              <EnrollmentPage
                isFromProfile={true}
                closeTo="/dashboard"
                successTo="/dashboard"
              />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* 🧑‍🎓 Student Dashboard */}
       <Route
  path="/dashboard"
  element={user ? <DashboardLayout /> : <Navigate to="/login" />}
>
  <Route path="dashboard" element={<UserDashboard />} />
  <Route path="profile" element={<Profile />} />
  <Route path="progress" element={<Progress />} />
  <Route path="schedule" element={<Schedule />} />
  <Route path="feedback" element={<Feedback />} />
  <Route path="notification" element={<Notification />} />
  
  {/* Default page */}
  <Route index element={<UserDashboard />} />
</Route>

        {/* 🚗 Driving School Dashboard */}
       <Route path="/school" element={<DrivingSchoolLayout />}>
  <Route path="dashboard" element={<DSHome />} />
  <Route path="students" element={<DSStudents />} />
  <Route path="vehicles" element={<DSVehicles />} />
  <Route path="profile" element={<DSProfile />} />
  <Route index element={<DSHome />} />
</Route>


        {/* 🏪 Vendor Dashboard */}
       <Route path="/vendor" element={<VendorLayout />}>
          <Route path="dashboard" element={<VDashboard />} />
          <Route path="vprofile" element={<VProfile />} />
          <Route path="my-services" element={<VMyServices />} />
          <Route path="vendorstudent" element={<VendorStudent />} />
          <Route path="bookings" element={<VendorBookings />} />
          <Route index element={<VDashboard />} />
        </Route>

        {/* 🧑‍💼 Agent Dashboard */}
        <Route path="/agent" element={<AgentLayout />}>
          <Route path="dashboard" element={<AgentDashboard />} />
          <Route path="students" element={<AgentStudents />} />
          <Route path="commissions" element={<AgentCommissions />} />
          <Route path="profile" element={<AgentProfile />} />
          <Route index element={<AgentDashboard />} />
        </Route>

        {/* 🌐 Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default AppRouter;
